const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
	payment_tiktok_for_export: [],
};

function paymentTiktokReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_PAYMENT_TIKTOK':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_PAYMENT_TIKTOK':
			return {
				...state,
				list: action?.payload?.paymenttiktoks || [],
				totalsize: action?.payload?.totalsize || 0
			};
		case 'EXPORT_PAYMENT_TIKTOK':
			return {
				...state,
				payment_tiktok_for_export: action.payload.payment_tiktok_for_export
			};
		default:
			return state;
	}
}

export default paymentTiktokReducer;
